import axios from 'axios'
import moment from 'moment'

export const getDifferenceData = timestamp => {
    // console.log('got timestamp', timestamp)
    const startTime = moment.unix(timestamp / 1000)
    const end = moment.utc()

    const difference = moment.duration(end.diff(startTime))
    const secs = difference.asSeconds()

    let {
        days, hours, minutes, seconds
    } = difference._data

    if (days > 0) {
        days = `${days} days & `
    } else {
        days = ''
    }

    if (hours > 0 && hours < 10) {
        hours = '0' + hours.toString()
    }

    if (minutes < 10) {
        minutes = '0' + minutes.toString()
    }

    if (seconds < 10) {
        seconds = '0' + seconds.toString()
    }

    const data = {
        elapsedTime: `${days}${
            hours ? hours + ':' : ''
        }${minutes}:${seconds} ago`,
        elapsedSecs: secs,
    }

    return data
}

export const checkHealth = () => new Promise((resolve, reject) => axios('/health')
    .then(() => {
        resolve()
    })
    .catch(() => {
        reject()
    }))

export const logOut = () => {}
